import styled from "styled-components";
import { Text } from "@acko-tech/building-blocks.ui.typography";

export const CouponSuccessWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const AppliedText = styled(Text)`
  color: #040222;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const RemoveText = styled(Text)`
  color: #d83d37;
  font-size: 14px;
  font-weight: 500;
`;

export const SavedText = styled(Text)`
  color: #0fa457;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;
